<script setup lang="ts">
// TODO: place this in your user settings
const collapsed = ref<boolean>()
</script>

<template>
  <div class="main" :class="{ collapsed }">
    <div v-if="$slots.label" class="header">
      <div class="label" @click="collapsed = !collapsed">
        <slot name="label" />
      </div>
      <div class="actions">
        <slot name="actions" />
      </div>
    </div>
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.main
  @apply px-[#{$sidebar-p-main}] pb-3 pt-3
  &.collapsed
    .content
      @apply hidden

.header
  @apply flex t-sidebar-item text-[#{$sidebar-t-header}] mb-[#{$sidebar-gap-items-container}]

.label
  @apply text-[#{$sidebar-t-header}] t-sidebar-item
  &:hover
    @apply text-[#{$global-t-default}] cursor-pointer

.actions
  @apply flex items-center justify-center ml-auto
</style>
